module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/onboarding/components/onboarding-page/onboarding-page.component.html
// module id = ./src/app/onboarding/components/onboarding-page/onboarding-page.component.html
// module chunks = main